import React from "react";
import "../graphStyles.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import NoDataFound from "../../NoDataFound";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function GraphMissopportunities({ visitorWhoSawNudge, loading, dates }) {
  if (!Array.isArray(dates) || dates.length === 0) {
    console.error("Invalid or empty dates array.");
    return <NoDataFound />;
  }

  const validDates = dates.filter((date) =>
    visitorWhoSawNudge.hasOwnProperty(date)
  );

  if (validDates.length === 0) {
    console.error("No valid data found for the selected dates.");
    return <NoDataFound />;
  }

  const getTextSize = () => {
    return window.innerWidth < 1050 && window.innerWidth > 767
      ? "text-base"
      : "text-lg";
  };

  const calculateSumPerDate = (dataKey) =>
    validDates.map((date) => {
      const value = visitorWhoSawNudge[date][dataKey];
      return value ? value.reduce((acc, val) => acc + val, 0) : 0;
    });

  const data = {
    labels: validDates,
    datasets: [
      {
        label: "Exploratory Shoppers",
        data: calculateSumPerDate("ExploratoryShopppers"),
        borderColor: "rgba(255, 100, 0, 0.99)",
        backgroundColor: "rgba(255, 100, 0, 0.99)",
        hoverBackgroundColor: "rgba(255, 100, 0, 0.99)",
        type: "line",
        lineTension: 0.4,
        fill: false,
      },
      {
        label: "Engaged Shoppers",
        data: calculateSumPerDate("EngagedShoppers"),
        borderColor: "rgba(12, 150, 255, 0.99)",
        backgroundColor: "rgba(12, 150, 255, 0.5)",
        hoverBackgroundColor: "rgba(12, 150, 255, 0.5)",
        type: "line",
        lineTension: 0.4,
        fill: false,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          font: {
            size: function () {
              return window.innerWidth < 1050 && window.innerWidth > 767
                ? 10
                : 13;
            },
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: "weeks",
          font: {
            size: function () {
              return window.innerWidth < 1050 && window.innerWidth > 767
                ? 10
                : 13;
            },
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: function () {
              return window.innerWidth < 1050 && window.innerWidth > 767
                ? 10
                : 13;
            },
          },
        },
      },
      y: {
        title: {
          display: true,
          text: "Number of shoppers",
          font: {
            size: function () {
              return window.innerWidth < 1050 && window.innerWidth > 767
                ? 10
                : 13;
            },
          },
        },
      },
    },
  };

  console.log("Data : ", data);
  console.log("Options : ", options);

  return (
<div className="flex flex-col lg:flex-row p-3 bg-white border border-gray-200 rounded-lg shadow-md h-auto">
  <div className="flex-1 sm:w-1/10">
        <div className="flex items-center bg-gray-200 px-5 py-1">
          <h2 className="text-lg lg:text-lg font-bold text-gray-800 ms-12">
            CausalFunnel AI detected Missed Opportunities
          </h2>
        </div>
        {loading ? (
          <div className="flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="185px"
              height="185px"
              viewBox="0 0 100 100"
              preserveAspectRatio="xMidYMid"
            >
              <circle
                cx="50"
                cy="50"
                r="0"
                fill="none"
                stroke="#b927d4"
                strokeWidth="1"
              >
                <animate
                  attributeName="r"
                  repeatCount="indefinite"
                  dur="1.2658227848101264s"
                  values="0;51"
                  keyTimes="0;1"
                  keySplines="0 0.2 0.8 1"
                  calcMode="spline"
                  begin="0s"
                ></animate>
                <animate
                  attributeName="opacity"
                  repeatCount="indefinite"
                  dur="1.2658227848101264s"
                  values="1;0"
                  keyTimes="0;1"
                  keySplines="0.2 0 0.8 1"
                  calcMode="spline"
                  begin="0s"
                ></animate>
              </circle>
              <circle
                cx="50"
                cy="50"
                r="0"
                fill="none"
                stroke="#32c5ff"
                strokeWidth="1"
              >
                <animate
                  attributeName="r"
                  repeatCount="indefinite"
                  dur="1.2658227848101264s"
                  values="0;51"
                  keyTimes="0;1"
                  keySplines="0 0.2 0.8 1"
                  calcMode="spline"
                  begin="-0.6329113924050632s"
                ></animate>
                <animate
                  attributeName="opacity"
                  repeatCount="indefinite"
                  dur="1.2658227848101264s"
                  values="1;0"
                  keyTimes="0;1"
                  keySplines="0.2 0 0.8 1"
                  calcMode="spline"
                  begin="-0.6329113924050632s"
                ></animate>
              </circle>
            </svg>
          </div>
        ) : (
          <Bar className="w-half" options={options} data={data} />
        )}
      </div>
      <div className="flex flex-col justify-center lg:mt-0 lg:ml-20">
        <p className="text-gray-500 font-bold mb-11 w-40 xl:w-48 break-words text-2xl">
          Grab the missed opportunities and convert them into loyal customers!
        </p>

        <p className="mb-2">Your Persona Nudges are disabled</p>
        <button
          className="text-white bg-red-500 hover:bg-red-600 text-sm lg:text-base font-medium py-2 lg:py-3 px-6 lg:px-8 rounded-3xl transition duration-300 ease-in-out"
          onClick={() =>
            window.open("https://www.causalfunnel.com/contact/", "_blank")
          }
        >
          START FREE TRIAL
        </button>
      </div>
    </div>
  );
}
